import React from 'react';
import Icon from '@pushpay/icon';

const FavouriteIcon = props => {
  return /*#__PURE__*/React.createElement(Icon, Object.assign({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21.92 9.218a1.292 1.292 0 00-1.207-.834h-5.225a.43.43 0 01-.405-.284l-1.876-5.27a1.29 1.29 0 00-2.412 0l-.004.014L8.92 8.1a.428.428 0 01-.405.284H3.288a1.273 1.273 0 00-.827 2.256l4.45 3.66a.423.423 0 01.134.462l-1.87 5.557c-.225.67.14 1.392.815 1.615.396.13.832.063 1.168-.182l4.59-3.335a.432.432 0 01.506 0l4.588 3.335a1.295 1.295 0 001.8-.272c.248-.334.317-.767.184-1.16l-1.87-5.562a.423.423 0 01.134-.462l4.458-3.664a1.27 1.27 0 00.372-1.414z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

export default FavouriteIcon;